export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/opencart.d69bcc4.svg";